<template>
    <AuthLayout :loading="form.processing">
        <template #logo>
            <div class="flex justify-end items-center pb-8 ">
                <AppLogo />
            </div>
        </template>
        <div>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">Forgot your password?</h2>
            <p class="text-sm text-gray-600 mb-6">
                Enter your email address and we’ll send you a link to reset your password.
            </p>

            <form @submit.prevent="submit">
                <!-- Email Field -->
                <div class="mb-4">
                    <JetLabel for="email" value="Email" />
                    <JetInput id="email" v-model="form.email" type="email" class="mt-1 block w-full" required autofocus
                        autocomplete="email" />
                </div>

                <!-- Submit Button -->
                <div class="flex items-center justify-end mt-4">
                    <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Password reset link
                    </JetButton>
                </div>
            </form>

            <div v-if="status" class="bg-green-100 text-green-700 text-sm px-4 py-2 rounded mt-4">
                {{ status }}
            </div>

            <!-- Back to Login -->
            <p class="text-center text-sm text-gray-600 mt-6">
                Remember your password?
                <inertia-link :href="route('login')" class="text-green-600 font-semibold">
                    Back to login
                </inertia-link>
            </p>
        </div>
    </AuthLayout>
</template>

<script>
import AuthLayout from '@/Layouts/AuthLayout.vue'
import AppLogo from '@/Components/AppLogo.vue'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'

export default {
    components: {
        AuthLayout,
        AppLogo,
        JetButton,
        JetInput,
        JetLabel
    },

    props: {
        status: String
    },

    data() {
        return {
            form: this.$inertia.form({
                email: ''
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('password.email'))
        }
    }
}
</script>
